import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBox from "../components/common/SearchBox";
import { PlusIcon } from "../assets/Icons";
import AddApplication from "../Modals/AddApplication";
import apiClient from "../apiClient";
import { GET_ALL_APPLICATION } from "../apiClient/apiEndpoints";
import { SSO_URL } from "../env";
import moment from "moment/moment";
import NoDataFound from "../components/common/NoDataFound";

const Applications = () => {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [applicationModal, setApplicationModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getApplicationList = async () => {
    try {
      setLoading(true);
      const data = await apiClient.get(`${SSO_URL}${GET_ALL_APPLICATION}`);
      setList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getApplicationList();
  }, []);

  const filterApplications = list.filter((app) => app.name?.toLowerCase().includes(search?.toLowerCase()));

  return (
    <>
      <div className="main-list">
        <div className="page-title">
          <h5>Applications</h5>
        </div>
        <div className="section  p-4 pt-0">
          <div className="tags-sort my-3">
            <SearchBox search={search} setSearch={setSearch} />
            <button
              className="DefaultRedBtn"
              onClick={() => {
                setApplicationModal(true);
                setEditMode(false);
              }}
            >
              <PlusIcon />
              Create Application
            </button>
          </div>
          {filterApplications.length > 0 ? (
            <div className="list-view channels">
              <div className="list-here">
                {filterApplications.map((item, i) => (
                  <div
                    className="channel-card"
                    onClick={() => navigate(`/dashboard/applications/info/${item.uuid}`)}
                    key={i}
                  >
                    <span className="channel-logo">
                      {item?.icon ? (
                        <img src={item.icon} />
                      ) : (
                        <img src={"https://cdn.simulanis.io/sso/logos/default_simulanis.png"} />
                      )}
                    </span>
                    <span className="channel-detail">
                      <div className="tags">
                        <p className={item.active ? "active" : "inactive"}> {item.active ? "Active" : "Inactive"} </p>
                        <p className="channel-date"> {moment(item.createdAt).format("DD-MMM-YY")} </p>
                        <p className={item.accessType === "PRIVATE" ? "inactive" : "active"}>{item.accessType}</p>
                      </div>
                      <div className="details">
                        <p>{item.name}</p>
                        <p className="des">{item.description}</p>
                      </div>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ) : loading ? (
            <NoDataFound text="Fetching Data..." spacing="py-5" />
          ) : (
            <NoDataFound text="No Application Found" spacing="py-5" />
          )}
        </div>
      </div>

      <AddApplication
        applicationModal={applicationModal}
        setApplicationModal={setApplicationModal}
        editMode={editMode}
        refresh={getApplicationList}
        applicationList={list}
      />
    </>
  );
};

export default Applications;
